import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Button } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';

// Import your images here once you add them to the assets folder
// For now, we are using placeholders
import architectureImage from '../assets/images/architecture.png';
import layersImage from '../assets/images/layers.png';

const LandingPage = () => {
  const scrollToContent = (elementId) => {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
      });
    } else {
      window.scrollBy({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-[#212121] text-white">
      {/* Hero Section */}
      <section className="flex flex-col items-center justify-center h-screen text-center px-4">
        <Typography
          variant="h2"
          component="h1"
          className="mb-8 font-bold"
          gutterBottom
        >
          Your AI is lying to you.
        </Typography>

        <Typography variant="h5" component="p" className="mb-8 max-w-2xl" gutterTop>
          For high stakes use cases you need an AI precision layer.
        </Typography>
        <div className="flex flex-col items-center">
          <Button
            onClick={() => {
              scrollToContent('architecture');
              window.gtag('event', 'see_how_it_works_click');
            }}
            className="text-white"
            aria-label="Scroll down"
          >
            <Typography variant="body1" component="p" className="mb-2">
              See how it works
            </Typography>
            <ArrowDownward />
          </Button>
        </div>
      </section>

      {/* Architecture Section */}
      <section
        id="architecture"
        className="flex flex-col items-center justify-evenly h-screen text-center px-4 md:px-8"
      >
        <Typography variant="h3" component="h2" className="font-bold">
          A Reliable Source of Truth
        </Typography>
        <div className="max-w-5xl w-full">
          <img
            src={architectureImage}
            alt="a1facts.ai Architecture"
            className="w-full h-auto rounded-lg max-h-[70vh] object-contain mx-auto"
          />
        </div>
        <Button
          onClick={() => {
            scrollToContent('layers');
            window.gtag('event', 'tell_me_more_click');
          }}
          className="text-white"
          aria-label="Tell me more"
        >
          <Typography variant="body1" component="p" className="mr-2">
            Tell me more
          </Typography>
          <ArrowDownward />
        </Button>
      </section>

      {/* Layers Section */}
      <section
        id="layers"
        className="flex flex-col items-center justify-evenly h-screen text-center px-4 md:px-8 py-16"
      >
        <Typography variant="h3" component="h2" className="font-bold">
          How it works
        </Typography>
        <div className="max-w-5xl w-full">
          <img
            src={layersImage}
            alt="a1facts.ai Layers"
            className="w-full h-auto rounded-lg max-h-[50vh] object-contain mx-auto"
          />
        </div>
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-4">
          
          <a
            href="https://github.com/shadi-fsai/a1facts"
            rel="noopener noreferrer"
            onClick={(e) => {
              e.preventDefault();
              window.gtagSendEvent('https://github.com/shadi-fsai/a1facts');
            }}
            className="bg-green-600 text-white font-bold py-3 px-6 rounded-lg hover:bg-green-500 transition-colors duration-300 flex items-center text-lg"
          >
            <svg
              className="w-6 h-6 mr-2"
              fill="currentColor"
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path
                fillRule="evenodd"
                d="M12 2C6.477 2 2 6.477 2 12c0 4.418 2.865 8.168 6.839 9.492.5.092.682-.217.682-.482 0-.237-.009-.868-.014-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.031-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.378.203 2.398.1 2.65.64.7 1.03 1.595 1.03 2.688 0 3.848-2.338 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.001 10.001 0 0022 12c0-5.523-4.477-10-10-10z"
                clipRule="evenodd"
              />
            </svg>
            View on GitHub
          </a>
          <a
            href="https://docs.a1facts.ai/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => window.gtag('event', 'view_docs_click')}
            className="bg-gray-700 text-white font-bold py-3 px-6 rounded-lg hover:bg-gray-600 transition-colors duration-300 flex items-center text-lg"
          >
            View Docs
          </a>
        </div>
      </section>

      <footer className="w-full text-center py-6">
        <p className="text-sm text-gray-400">Copyright © Shadi Copty 2025</p>
      </footer>
    </div>
  );
};

export default LandingPage;